import {AfterViewInit, Component, ViewChild} from "@angular/core";
import {ICellEditorAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-number-text-box-editor',
    template: `<irb-number-text-box #numberTextBox
                                    [(value)]="params.value"
                                    [min]="min"
                                    [max]="max"
                                    [invalidMessage]="invalidMessage"
                                    [invalidRangeMessage]="invalidRangeMessage"
                                    [places]="places"
                                    [addZeroIfDotFirst]="addZeroIfDotFirst"
                                    width="100%"
                                    [class]="autoHeight ? 'auto-height' : ''"></irb-number-text-box>`
})
export class NumberTextBoxEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    params: any;
    cbFunc: Function;
    originalValue: any;
    places: number;
    min: number;
    max: number;
    invalidMessage: string;
    invalidRangeMessage: string;
    autofocus: boolean;
    autoSelect: boolean;
    autoHeight: boolean;
    addZeroIfDotFirst: boolean;

    @ViewChild('numberTextBox') numberTextBox: any;

    agInit(params: any): void {
        this.params = params;
        this.params.value = (this.params.value !== null) ? parseFloat(this.params.value) : this.params.value;
        this.originalValue = this.params.value;
        this.cbFunc = this.params.onUpdate || null;
        this.min = (this.params.min === 0) ? 0 : this.params.min || null;
        this.max = (this.params.max === 0) ? 0 : this.params.max || null;
        this.invalidMessage = this.params.invalidMessage || "Invalid input";
        this.invalidRangeMessage = this.params.invalidRangeMessage || "Invalid range";
        this.places = this.params.places || 0;
        this.autofocus = this.params.autofocus || false;
        this.autoSelect = this.params.autoSelect || false;
        this.autoHeight = this.params.autoHeight || false;
        this.addZeroIfDotFirst = this.params.addZeroIfDotFirst || false;
    }

    getValue(): any {
        if (this.params.roundIfInvalid && !this.numberTextBox.inputControl.valid) {
            if (this.numberTextBox.inputControl.value === this.originalValue) {
                return this.originalValue;
            }

            const roundedValue: any = Number(Number(this.numberTextBox.inputControl.value).toFixed(this.places));
            this.numberTextBox.inputControl.setValue(roundedValue);
            this.params.value = roundedValue;
        }

        if(this.numberTextBox.inputControl.valid) {
            setTimeout(() => {
                if(this.cbFunc) {
                    this.cbFunc(this.params);
                } 
            });
            
            this.params.value = (typeof this.params.value === "string" && this.params.value.length === 0) ? 0 : this.params.value;
            this.params.value = (this.params.value !== null) ? parseFloat(this.params.value) : this.params.value;
            return (this.params.value) ? this.params.value : null;
        } else {
            return this.originalValue;
        }
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            setTimeout(() => {
                if (this.numberTextBox.inputField && this.numberTextBox.inputField.nativeElement) {
                    const input = this.numberTextBox.inputField;
                    input.nativeElement.focus();
                    if (this.autoSelect) {
                        const length = input.nativeElement.value
                          ? input.nativeElement.value.length
                          : 0;
                        if (length > 0) {
                            input.nativeElement.select();
                        }
                    }

                }
            }, 200);
        }
    }
}
